import React from 'react';
import styled from 'styled-components';

const SummaryContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  height: 100%;
`;

const Tagline = styled.p`
  font-size: 16px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.9);
  margin: 0 0 8px 0;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const SectionTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  margin: 0;
  font-family: 'Inter', sans-serif;
`;

const SectionContent = styled.div`
  font-size: 14px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.8);
  font-family: 'Inter', sans-serif;
  
  ul {
    margin: 8px 0;
    padding-left: 20px;
    list-style-type: disc;
    
    li {
      margin-bottom: 6px;
    }
  }
`;

const BulletList = styled.ul`
  margin: 8px 0;
  padding-left: 20px;
  list-style-type: disc;
  
  li {
    margin-bottom: 6px;
    color: rgba(255, 255, 255, 0.8);
    font-size: 14px;
    line-height: 1.6;
    font-family: 'Inter', sans-serif;
  }
`;

const WhitepaperSummary: React.FC = () => {
  return (
    <SummaryContainer>
      <Tagline>
        MAVRK is an autonomous onchain index that accumulates value from Mavrk-launched tokens and recursively turns that value into deeper liquidity for the entire ecosystem.
      </Tagline>

      <Section>
        <SectionTitle>Ecosystem Index Fund</SectionTitle>
        <SectionContent>
          MAVRK accumulates ecosystem tokens via LP trading fees from Mavrk-launched pools. Over time it holds a basket of the ecosystem's strongest performers, turning protocol activity into index exposure.
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>Recursive Liquidity Engine</SectionTitle>
        <SectionContent>
          The MAVRK Index Fund rotates accumulated tokens into MAVRK-backed liquidity positions (e.g., MAVRK/COIN CLMM pools). This rotation pushes value into MAVRK while locking successful ecosystem tokens in LP, deepening liquidity without selling into the market.
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>Separation from the Core Protocol</SectionTitle>
        <SectionContent>
          MAVRK is not required to use the protocol, not a base pair requirement, and does not gate deployments. The Mavrk protocol remains immutable and non-governed; MAVRK sits on top as a meta-asset layer.
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>Investor & Ecosystem Alignment</SectionTitle>
        <SectionContent>
          A narrow-scope DAO (raise-round investors only) manages the index treasury (HOLD / PAIR / ROTATE actions only). Ecosystem growth, trading fees, and MAVRK value all reinforce each other in a circular flywheel.
        </SectionContent>
      </Section>
    </SummaryContainer>
  );
};

export default WhitepaperSummary;

